/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_li_faq3_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Why do designers use Lorem Ipsum instead of real text?`)
};

const es_li_faq3_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`¿Por qué los diseñadores usan Lorem Ipsum en lugar de texto real?`)
};

const de_li_faq3_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Warum verwenden Designer Lorem Ipsum statt echtem Text?`)
};

const nl_li_faq3_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Waarom gebruiken ontwerpers Lorem Ipsum in plaats van echte tekst?`)
};

const fr_li_faq3_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pourquoi les concepteurs utilisent-ils Lorem Ipsum au lieu de vrai texte ?`)
};

const it_li_faq3_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Perché i designer usano Lorem Ipsum invece di testo vero?`)
};

const pt_br2_li_faq3_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Por que os designers usam Lorem Ipsum em vez de texto real?`)
};

const pt_li_faq3_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Por que os designers usam Lorem Ipsum em vez de texto real?`)
};

const ja_li_faq3_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`なぜデザイナーはLorem Ipsumの代わりに実際のテキストを使うのですか？`)
};

const zh_li_faq3_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`为什么设计师使用Lorem Ipsum而不是真实文本？`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const li_faq3_q = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.li_faq3_q(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("li_faq3_q", locale)
	if (locale === "en") return en_li_faq3_q(inputs)
	if (locale === "es") return es_li_faq3_q(inputs)
	if (locale === "de") return de_li_faq3_q(inputs)
	if (locale === "nl") return nl_li_faq3_q(inputs)
	if (locale === "fr") return fr_li_faq3_q(inputs)
	if (locale === "it") return it_li_faq3_q(inputs)
	if (locale === "pt-BR") return pt_br2_li_faq3_q(inputs)
	if (locale === "pt") return pt_li_faq3_q(inputs)
	if (locale === "ja") return ja_li_faq3_q(inputs)
	return zh_li_faq3_q(inputs)
};